import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Agent from "../../Network/Agent";
import { set } from "nprogress";
import { is } from "date-fns/locale";
import { Link, useSearchParams } from "react-router-dom";

export default function SiteDownHistory() {
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);
    const [site_id, setSiteId] = useState('');
    const [tenant_id, setTenantId] = useState('');
    const [selector, setSelector] = useState({});
    const [history, setHistory] = useState([]);
    // get tenant id from request url is tenant_id;
    const [tenantLoaded, setTenantLoaded] = useState(false);
    const [searchParams] = useSearchParams();
    // useEffect(() => {

    //     const params = new URLSearchParams(window.location.search);

    //     const tid = params.get("tenant_id") || "";

    //     setTenantId(tid);

    //     setTenantLoaded(true);

    // }, []);

    const array_data = useRef({
        page: 1,
        site_id: "",
        tenant_id: "",
        filter_type: "is_active",
        lodeMore: false,
    });



    useEffect(() => {
       //  if (!tenantLoaded) return;
        setLoading(true);
        array_data.current.site_id = site_id;
        array_data.current.page = page;
        array_data.current.tenant_id = searchParams.get("tenant_id")??'';
        if (page != 1) {
            array_data.current.lodeMore = true;
        }

        Agent.All_RMS.siteDownHistory(array_data.current).then((response) => {
            if (response) {
                // console.log("Site Down History Response:", response.data);
                setSelector(response.data);
                if (array_data.current.lodeMore) {
                    setHistory((prevHistory) => [...prevHistory, ...response.data.history]);
                } else {
                    setHistory(response.data.history);
                }
            } else {
                // console.error("Failed to fetch site down history.");
            }
            setLoading(false);
        });

    }, [page, site_id, searchParams.get("tenant_id")]);

    const searchSite = (site_code) => {
        setPage(1)
        setSiteId(site_code);
    }


    const syncData = () => {


    }

    const callbackSearch = (form_data) => {
        array_data.current.site_id = form_data.site_id;
        array_data.current.page = form_data.page;
        array_data.current.lodeMore = false;
    }



    const observer = useRef();
    const lastElementRef = useCallback((element) => {
        //element is the react element being referenced

        // disconnect observer set on previous last element
        if (observer.current) observer.current.disconnect();

        // if there's no more data to be fetched, don't set new observer
        if (!selector?.data?.has_more_page) return;

        // set new observer
        observer.current = new IntersectionObserver((entries) => {
            // increase page number when element enters (is intersecting with) viewport.
            // This triggers the pagination hook to fetch more items in the new page
            if (entries[0].isIntersecting && selector?.data?.has_more_page) setPage((prev) => prev + 1);
        });

        // observe/monitor last element
        if (element) observer.current.observe(element);
    }, [selector?.data?.has_more_page]);

    return (
        <div className="row ms-1 me-1">

            <div className="card col-md-12">
                <div className="card-header">
                    <div className="d-flex justify-content-between">
                        <h5>All Site Down History  {loading ? (
                            <span
                                className="spinner-border spinner-border-sm ml-5 ms-2"
                                role="status"
                                aria-hidden="true"
                            ></span>
                        ) : (
                            <span></span>
                        )}

                        </h5>
                        <div>
                            <div class="input-group input-group-sm"><span class="input-icon-addon"><i class="fa fa-search"></i></span>
                                <input type="text" className="form-control" placeholder="Search site id.." onChange={(e) => searchSite(e.target.value)} />
                                <button type="button" className="input-group-text" onClick={() => syncData()}><i className="fa-solid fa-sync me-2"></i> Sync </button>
                                <Link to="/rms_alarm_filter/26/fatch" className="input-group-text info-primary" >History Alarm</Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-body p-0">
                    <div className="table-responsive scrol-table-height mt-1" >

                        <table className="table thead-light rms_table table-bordered bg-white table-striped m-0 text-center">
                            <thead className="text-uppercase">

                                <tr>
                                    <th>Site ID</th>
                                    <th>Tenant</th>
                                    <th>Mains Fail Start</th>
                                    <th>DC Low Start</th>
                                    <th>Site Down Start</th>
                                    <th>Battery Backup</th>
                                </tr>
                            </thead>
                            <tbody>

                                {history.map((item, index) => {
                                    return (
                                        <tr key={index} ref={history.length === index + 1 ? lastElementRef : null}>
                                            <td><a href={`/site/${item.site_id}`} className="text-dark fw-bold">{item.site_id}</a></td>
                                            <td className="text-dark fw-bold">{item.tenant_name}</td>
                                            <td>{item.mf_start}</td>
                                            <td>{item.dclow_start}</td>
                                            <td>{item.site_down_start}</td>
                                            <td className="fw-bold">{item.battery_backup}</td>
                                        </tr>
                                    )
                                }
                                )}
                                <p>{history.length === 0 ? "No data available" : ""}</p>
                                <p>{loading ? "Loading..." : ""}</p>
                            </tbody>
                        </table>
                    </div>
                    <p className="p-0 m-0 fs-12">Current Display 1 - {history.length} Record(s), {selector?.data?.total_page} Record(s) Totally</p>
                </div>
            </div>
        </div>
    )
}